export default function(nga, admin) {
    let entity = admin.getEntity('gamevr')
        .label('GAMEVR');

    entity.listView()
        .title('GAMEVR')
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'),
            nga.field('included', 'boolean').label('INCLUDED')
        ])
        .sortDir('asc')
        .url('gamevrs');

    entity.showView()
        .fields([
            nga.field('id').label('ID'),
            nga.field('name').label('NAME'),
            nga.field('description').label('DESCRIPTION'),
            nga.field('included', 'boolean').label('INCLUDED')
        ]);

    entity.creationView()
        .fields([
            nga.field('name').label('NAME'),
            nga.field('description').label('DESCRIPTION'),
            nga.field('included', 'boolean').label('INCLUDED')
                .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')
    ]);

    entity.editionView().fields(
        entity.creationView().fields()
    );
    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/gamevr/config.js
 **/